import type { IconData } from '@stacksjs/iconify-core'

export const lightbulb: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M252.592 496h6.816a108.12 108.12 0 0 0 108-108v-55.692a177.48 177.48 0 0 0 66.37-138.531C433.778 95.751 354.027 16 256 16S78.222 95.751 78.222 193.777a177.48 177.48 0 0 0 66.371 138.531V388a108.12 108.12 0 0 0 107.999 108m6.816-32h-6.816a76.11 76.11 0 0 1-70.631-48H330.04a76.11 76.11 0 0 1-70.632 48m76-80H176.593v-40h158.815ZM110.222 193.777C110.222 113.4 175.618 48 256 48s145.778 65.4 145.778 145.777a146.4 146.4 0 0 1-59.817 117.737l-.661.486H170.7l-.665-.486a146.4 146.4 0 0 1-59.813-117.737\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default lightbulb
